import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const downloadAdminPurchaseOrderPdf = createAsyncThunk(
    "/admin/download-admin-po-pdf",
    async (id, { rejectWithValue }) => {
        try {
            const myurl = `${V_URL}/believe/download-po-pdf/${id}`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                toast.error(data.message || "Failed to generate Purchase Order PDF");
                return rejectWithValue(data);
            }
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Something went wrong";
            toast.error(message);
            return rejectWithValue(error.response?.data || message);
        }
    }
);

const downloadAdminPurchaseOrderSlice = createSlice({
    name: "downloadAdminPurchaseOrder",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(downloadAdminPurchaseOrderPdf.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(downloadAdminPurchaseOrderPdf.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(downloadAdminPurchaseOrderPdf.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default downloadAdminPurchaseOrderSlice.reducer;
